import React from "react";
import DeferredVideo from "./DeferredVideo";

export default function RecipeHighlightSection({
  title,
  highlight,
  description,
  buttonText,
  buttonLink,
  videoSrc,
  videoPoster,
}) {
  return (
    <section className="py-16 bg-[#FBF5EE]">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
        
        {/* LEFT CONTENT */}
        <div className="md:w-1/2">
          <h2 className="text-4xl sm:text-5xl font-semibold text-gray-900 leading-snug mb-5">
            {title.split(highlight)[0]}
            <span className="text-[#C03CA0] font-bold">{highlight}</span>
            {title.split(highlight)[1]}
          </h2>

          <p className="text-gray-700 mb-6 leading-relaxed">
            {description}
          </p>

          <a
            href={buttonLink}
            className="inline-block bg-[#C03CA0] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#a03083] transition"
          >
            {buttonText}
          </a>
        </div>

        {/* RIGHT VIDEO */}
        <div className="md:w-1/2 w-full rounded-2xl overflow-hidden shadow-lg">
          <DeferredVideo
            src={videoSrc}
            poster={videoPoster}
            className="w-full h-auto object-cover rounded-2xl"
            style={{
              maxHeight: "460px",
            }}
          />
        </div>
      </div>
    </section>
  );
}
